export default __webpack_public_path__ + "static/media/philosophy.7d3b4030.svg";